/** "Patrycja A": first name and the first letter of the last name (full names are only shown in edit forms). */
export const shortName = (firstName, lastName) =>
  [String(firstName || "").trim(), String(lastName || "").trim().charAt(0).toUpperCase()]
    .filter(Boolean)
    .join(" ");


/** "Patrycja A" from an already joined "Patrycja Adeoye". */
export const shortFullName = (fullName) => {
  const parts = String(fullName || "").trim().split(/\s+/).filter(Boolean);
  return parts.length < 2 ? parts[0] || "" : shortName(parts[0], parts[parts.length - 1]);
};
